import { convertNumber } from "utils/convertNumber/ConvertNumber"

interface Props {
  value: number | null
  currencyCode?: string | null
}


const ShowValue = ({ value, currencyCode }: Props) => {


  return (<>{value === null ? '' : `${convertNumber(value)} ${currencyCode ? currencyCode : 'USD'}`} </>)
}

export { ShowValue }
